var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1191_1316",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.183594,
    width: 40,
    height: 40,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1191_1316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5196 35.1887H28.4796C31.4596 35.1887 33.8796 32.7687 33.8796 29.7887V14.7587C33.8796 14.2287 33.4496 13.7987 32.9196 13.7987H27.1796V12.3587C27.1796 8.39871 23.9596 5.17871 19.9996 5.17871C16.0396 5.17871 12.8196 8.39871 12.8196 12.3587V13.7987H7.07962C6.54962 13.7987 6.11963 14.2287 6.11963 14.7587V29.7887C6.11963 32.7687 8.53962 35.1887 11.5196 35.1887ZM14.7296 12.3687C14.7296 9.46871 17.0896 7.10871 19.9896 7.10871C22.8896 7.10871 25.2496 9.46871 25.2496 12.3687V13.8087H14.7196V12.3687H14.7296ZM8.02962 15.7187H12.8196V18.1087C12.8196 18.6387 13.2496 19.0687 13.7796 19.0687C14.3096 19.0687 14.7396 18.6387 14.7396 18.1087V15.7187H25.2696V18.1087C25.2696 18.6387 25.6996 19.0687 26.2296 19.0687C26.7596 19.0687 27.1896 18.6387 27.1896 18.1087V15.7187H31.9796V29.7887C31.9796 31.7087 30.4196 33.2687 28.4996 33.2687H11.5396C9.61963 33.2687 8.05962 31.7087 8.05962 29.7887V15.7187H8.02962Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagOn);
export default __webpack_public_path__ + "static/media/bag_on.9bb49cf4dbb2e1a3336906229871e5cc.svg";
export { ForwardRef as ReactComponent };